import { render, staticRenderFns } from "./contact-page.vue?vue&type=template&id=66c80dca&lang=pug&"
import script from "./contact-page.vue?vue&type=script&lang=js&"
export * from "./contact-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports